const getVideos = async (filters) => {
    const awsGateway = process.env.REACT_APP_AWS_GATEWAY === undefined
        ? process.env.AWS_GATEWAY
        : process.env.REACT_APP_AWS_GATEWAY
    let response = {
        ok:false,
        message:'',
        data:null
    }
    try{
        function concatUrl(url, params){
            const u = new URL(url);
            Object.entries(params).forEach(([k, v]) => {
                const val = typeof v === 'string' ? v.trim() : v;
                if (val !== undefined && val !== null && val !== '') {
                    u.searchParams.set(k, val);
                }
            });
            return u;
        }
        let {orderByAsc, searchText, filterBy, indexPage, product} = filters
        const url = awsGateway + '/media/video'

        const vals = {
            search: (searchText || '').trim(),
            page: indexPage,
            sortdirection: orderByAsc ? 'asc' : 'desc',
            sortby: filterBy
        }
        if (product) vals.product = product;
        let header  = new Headers()
        header.append('Content-Type','application/json')
        const urlRequest = concatUrl(url,vals)
        await fetch(urlRequest.href,{
        method:'GET',
        headers:header

       }).then(async (res) => {

           response.ok = res.ok
           response.data = await res.json()


        }).catch(error =>{

            response.message = error
        })
    }
    catch(error){

        response.message = error
    }
     return await response;

}
export default getVideos